import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExceptionService } from '../shared/services/exception.service';
import { NotificationService } from '../shared/services/notification.service';
import { UtilService } from '../shared/services/util.service';
import * as constant from '../shared/constants/constants';
import { NavigationExtras, Router } from '@angular/router';
import { UrlSecurityService } from '../shared/services/url-security.service';
import { localStorageKeys, notificationNavigation, statusCodeValues } from '../core/enum';
import { ResponsiveService } from '../shared/responsive/responsive.service';
import { StorageService } from '../shared/services/storage.service';



@Component({
  selector: 'app-notification-menu',
  templateUrl: './notification-menu.component.html',
  styleUrls: ['./notification-menu.component.scss']
})
export class NotificationMenuComponent {
  /**variable to show notification panel*/
  is_notification_visible: boolean;

  /**notification list variables */
  notification_data: any[] = []
  notification_length:any;

  /**get enums*/
  message_status_code : any = statusCodeValues
  notification_navigtion : any = notificationNavigation

  constructor(public utilService: UtilService,
    private notificationService: NotificationService,
    private exceptionService: ExceptionService,
    private translateService: TranslateService,
    private router: Router,
    public urlService: UrlSecurityService,
    public responsiveService: ResponsiveService,
   private storageService: StorageService) {

    /**show the notification panel*/
    this.utilService.notification_visible.subscribe((value: any) => {
      this.is_notification_visible = value;

      /**calling to get notification list and Notification Status*/
      this.getStatus();
      this.getNotificationService();
    })

    /**
     * to check notification status after 1min
     */
    this.notificationService.triggerNotificationStatus.subscribe((is_active: any) => {
      if (is_active) {
        this.getNotificationStatus(); 
      }
    })
  }

  /**calling for notification status */
  async getNotificationStatus(){
    const isMarketAvailable = await this.storageService.get(localStorageKeys.market)
    if(!isMarketAvailable)
      return
    this.notificationService.getNotificationStatuService().subscribe({
      next: (response: any) => {
        setTimeout(() => {
          this.notificationService.triggerNotificationStatus.next(true)
        }, constant.common.notification_time)
        this.notificationService.triggerNotificationSymbol.next(response.is_notify)
      },
      error: (error: any) => {
        this.exceptionService.toastMessage(error.status, error.body);
      }
    });
  }

  async getStatus(){
    const isMarketAvailable = await this.storageService.get(localStorageKeys.market)
    if(!isMarketAvailable)
      return
    this.notificationService.getNotificationStatuService().subscribe({
      next: (response: any) => {
        this.notificationService.triggerNotificationSymbol.next(response.is_notify)
      },
      error: (error: any) => {
        this.exceptionService.toastMessage(error.status, error.body);
      }
    });
  }

  
  /**get the notification List */
  getNotificationService() {
    this.notificationService.getNotificationService().subscribe({
      next: (response: any) => {
      
        this.notification_length = response.length;

        /**variable for group notification */
        const _groupedNotifications: { [key: string]: any } = {};
    
        /**iterate on notification list */
        response.forEach((_Item: any) => {
            const notificationDate = new Date(_Item.modified_at);
            const _dateKey = this.utilService.describeDate(notificationDate);

          /**show messsage status on notification */
          let _messageShow = '';

          if (_Item?.opt_status_id == this.message_status_code?.completed) {
            _messageShow = this.translateService.instant(constant.notification.notification_desc) + '"' + _Item.scenario_name + '"' + this.translateService.instant(constant.notification.generated_success);

            if (_Item?.status_id == this.message_status_code?.approved) {
              _messageShow = _Item.username + this.translateService.instant(constant.notification.submitted_scenario) + '"' + _Item.scenario_name + '"';
            }
            if (_Item?.status_id == this.message_status_code?.in_review) {
              _messageShow = _Item.username + this.translateService.instant(constant.notification.submit_for_approval) + '"' + _Item.scenario_name + '"';
            }
            if (_Item?.status_id == this.message_status_code?.rejected) {
              _messageShow = _Item.username + this.translateService.instant(constant.notification.rejected_message) + '"' + _Item.scenario_name + '"';
            }
          } else if (_Item?.opt_status_id == this.message_status_code?.failed) {
            _messageShow = this.translateService.instant(constant.notification.notification_desc) + '"' + _Item.scenario_name + '"' + this.translateService.instant(constant.notification.failed);
          }   
          
          /**check notification by day as today,yesterday */
            if (!_groupedNotifications[_dateKey]) {
              _groupedNotifications[_dateKey] = {
                    day: notificationDate,
                    notification_data: []
                };
            }
    
            /**push the notification details by day to group them*/
            _groupedNotifications[_dateKey].notification_data.push({
                img_url: constant.notification.image_url,
                name: _Item.username,
                desc: _messageShow,
                created_at: _Item.modified_at,
                is_active: _Item.is_active,
                is_notify: _Item?.is_notify,
                scenario_id: _Item?.scenario_id,
                time: new Date(_Item.modified_at),
                status_id: _Item.status_id
            });
        });
    
        /**convert notification object as array */
        this.notification_data = Object.values(_groupedNotifications);
      },
      error: (error: any) => {
        this.exceptionService.toastMessage(error.status, error.body);
      }
    });
  }

  /**redirect to price recommender page */
  redirectToRoute(notification: any) {
    let payload = {
      "scenario_id": this.urlService.encrypt(notification?.scenario_id.toString())
    }
    const navigationExtras: NavigationExtras = {
      queryParams: { '': new Date().getTime() } ,  
    };
    if(this.notification_navigtion[notification?.status_id]){
      this.router.navigate([this.notification_navigtion[notification?.status_id]], navigationExtras)
    }else{
      this.router.navigate([constant.navigation.priceRecommendationLanding], navigationExtras);
    } 
    this.is_notification_visible = !this.is_notification_visible; 
    this.readNotificationService(payload); 
  }

  /**read the notification status */
  readNotificationService(payload:any) {
    this.notificationService.readNotificationService(payload).subscribe({
      next: (response: any) => {
        this.getIndividualNotificationStatus();
        this.notificationService.triggerNotificationStatus.next(true);
      },
      error: (error: any) => {
        this.exceptionService.toastMessage(error.status, error.body);
      }
    });
  }

  getIndividualNotificationStatus(){
    this.notificationService.getNotificationStatuService().subscribe({
      next: (response:any) => {
        this.notificationService.triggerNotificationSymbol.next(response.is_notify)
       }
    })
  }

  /**close p-sidebar on close button */
  closePanel(){
    this.is_notification_visible = !this.is_notification_visible;
  }

  /**read all the notification */
  readAllNotification(){
    this.notificationService.readAllNotificationService().subscribe({
      next:()=>{
        this.notificationService.triggerNotificationSymbol.next(false)
        this.getNotificationService();
      },
      error: (error: any) => {
        this.exceptionService.toastMessage(error.status, error.body);
      }
    })
  }

}
